export const renderLayoutPreview = (layout: string): JSX.Element | null => {
	switch (layout) {
		case "standard":
			return (
				<div className="flex w-full gap-1">
					<div className="bg-blue-500 w-5 h-4"></div>
					<div className="bg-gray-300 w-3 h-4"></div>
					<div className="bg-gray-300 w-3 h-4"></div>
					<div className="bg-gray-300 w-3 h-4"></div>
					<div className="bg-gray-300 w-3 h-4"></div>
				</div>
			);
		case "centered":
			return (
				<div className="flex justify-center w-full gap-1">
					<div className="bg-blue-500 w-5 h-4"></div>
					<div className="bg-gray-300 w-3 h-4"></div>
					<div className="bg-gray-300 w-3 h-4"></div>
					<div className="bg-gray-300 w-3 h-4"></div>
				</div>
			);
		case "split":
			return (
				<div className="flex justify-between w-full">
					<div className="bg-blue-500 w-5 h-4"></div>
					<div className="flex gap-1">
						<div className="bg-gray-300 w-3 h-4"></div>
						<div className="bg-gray-300 w-3 h-4"></div>
						<div className="bg-gray-300 w-3 h-4"></div>
					</div>
				</div>
			);
		case "logo-left":
			return (
				<div className="grid grid-cols-2 w-full gap-1">
					<div className="bg-blue-500 w-5 h-4"></div>
					<div className="flex justify-end gap-1">
						<div className="bg-gray-300 w-2 h-4"></div>
						<div className="bg-gray-300 w-2 h-4"></div>
						<div className="bg-gray-300 w-2 h-4"></div>
					</div>
				</div>
			);
		case "logo-right":
			return (
				<div className="grid grid-cols-2 w-full gap-1">
					<div className="flex gap-1">
						<div className="bg-gray-300 w-2 h-4"></div>
						<div className="bg-gray-300 w-2 h-4"></div>
						<div className="bg-gray-300 w-2 h-4"></div>
					</div>
					<div className="flex justify-end">
						<div className="bg-blue-500 w-5 h-4"></div>
					</div>
				</div>
			);
		case "three-columns":
			return (
				<div className="grid grid-cols-3 w-full gap-1">
					<div className="flex justify-start">
						<div className="bg-gray-300 w-3 h-4"></div>
					</div>
					<div className="flex justify-center">
						<div className="bg-blue-500 w-5 h-4"></div>
					</div>
					<div className="flex justify-end gap-1">
						<div className="bg-gray-300 w-2 h-4"></div>
						<div className="bg-gray-300 w-2 h-4"></div>
					</div>
				</div>
			);
		case "stacked":
			return (
				<div className="flex flex-col items-center gap-1 w-full">
					<div className="bg-blue-500 w-6 h-2"></div>
					<div className="flex justify-center gap-1 w-full">
						<div className="bg-gray-300 w-2 h-2"></div>
						<div className="bg-gray-300 w-2 h-2"></div>
						<div className="bg-gray-300 w-2 h-2"></div>
						<div className="bg-gray-300 w-2 h-2"></div>
					</div>
				</div>
			);
		case "minimalist":
			return (
				<div className="flex justify-between w-full">
					<div className="bg-blue-500 w-3 h-4"></div>
					<div className="bg-gray-300 w-2 h-4"></div>
				</div>
			);
		case "dual-row":
			return (
				<div className="flex flex-col gap-1 w-full">
					<div className="flex justify-between w-full">
						<div className="bg-blue-500 w-4 h-2"></div>
						<div className="flex gap-1">
							<div className="bg-gray-300 w-2 h-2"></div>
							<div className="bg-gray-300 w-2 h-2"></div>
						</div>
					</div>
					<div className="flex justify-center gap-1 w-full">
						<div className="bg-gray-300 w-2 h-2"></div>
						<div className="bg-gray-300 w-2 h-2"></div>
						<div className="bg-gray-300 w-2 h-2"></div>
						<div className="bg-gray-300 w-2 h-2"></div>
					</div>
				</div>
			);
		case "asymmetric":
			return (
				<div className="grid grid-cols-3 w-full gap-1">
					<div className="col-span-2 flex items-center">
						<div className="bg-blue-500 w-4 h-4 mr-1"></div>
						<div className="bg-gray-300 flex-1 h-3"></div>
					</div>
					<div className="flex justify-end gap-1">
						<div className="bg-gray-300 w-2 h-4"></div>
						<div className="bg-gray-300 w-2 h-4"></div>
					</div>
				</div>
			);
		case "logo-centered-nav-below":
			return (
				<div className="flex flex-col items-center gap-1 w-full">
					<div className="bg-blue-500 w-6 h-2 mb-1"></div>
					<div className="flex justify-between w-full">
						<div className="bg-gray-300 w-2 h-2"></div>
						<div className="bg-gray-300 w-2 h-2"></div>
						<div className="bg-gray-300 w-2 h-2"></div>
						<div className="bg-gray-300 w-2 h-2"></div>
						<div className="bg-gray-300 w-2 h-2"></div>
					</div>
				</div>
			);
		// New layout previews
		case "multirow":
			return (
				<div className="flex flex-col gap-1 w-full">
					<div className="flex justify-end w-full gap-1 pb-1 border-b border-gray-200">
						<div className="bg-gray-300 w-2 h-2"></div>
						<div className="bg-gray-300 w-2 h-2"></div>
					</div>
					<div className="flex justify-between w-full pt-1">
						<div className="bg-blue-500 w-4 h-2"></div>
						<div className="flex gap-1">
							<div className="bg-gray-300 w-2 h-2"></div>
							<div className="bg-gray-300 w-2 h-2"></div>
							<div className="bg-gray-300 w-2 h-2"></div>
						</div>
					</div>
				</div>
			);
		case "compact":
			return (
				<div className="flex justify-between w-full py-0">
					<div className="bg-blue-500 w-4 h-3"></div>
					<div className="flex gap-0.5">
						<div className="bg-gray-300 w-1.5 h-3"></div>
						<div className="bg-gray-300 w-1.5 h-3"></div>
						<div className="bg-gray-300 w-1.5 h-3"></div>
						<div className="bg-gray-300 w-1.5 h-3"></div>
					</div>
				</div>
			);
		case "overlay":
			return (
				<div className="relative w-full">
					<div className="absolute inset-0 bg-white bg-opacity-70 backdrop-blur-sm flex justify-between items-center px-1">
						<div className="bg-blue-500 w-4 h-3"></div>
						<div className="flex gap-1">
							<div className="bg-gray-300 w-2 h-3"></div>
							<div className="bg-gray-300 w-2 h-3"></div>
						</div>
					</div>
					<div className="w-full h-4 bg-gray-100"></div>
				</div>
			);
		default:
			return null;
	}
};
